<template>
  <div class="flex flex-col items-center gap-2">
    <TitreDeux :content="t('createPrinter')" />

    <InputField :placeholder="t('brand')" v-model="newMarque" class="!w-full"/>
    <InputField :placeholder="t('model')" v-model="newModel" class="!w-full"/>
    <InputField :placeholder="t('consommation')" v-model="newConsommation" type="number" class="!w-full"/>
    <InputField :placeholder="t('price')" v-model="newPrix" type="number" class="!w-full"/>
    <InputField :placeholder="t('urlImgPrinter')" v-model="newUrlImage" class="!w-full"/>
    <DropDownField :placeholder="t('purchaseType')" :values="typeAchatAvailable" v-model="newTypeAchat" class="!w-full"/>
    <InputField :placeholder="t('ip')" v-model="newIp" class="!w-full"/>

    <BlueButton :text="t('addAction')" @click="createImprimante" class="w-full " />
  </div>
</template>

<script setup>

import {computed, ref} from "vue";
import InputField from "@/components/molecules/InputField.vue";
import BlueButton from "@/components/molecules/BlueButton.vue";
import {t} from "@/utils/Traduction";
import {NotificationStores} from "@/stores/NotificationStores";
import {ImprimantesStore} from "@/stores/ImprimanteStore";
import DropDownField from "@/components/molecules/DropDownField.vue";
import {TypeAchatStore} from "@/stores/TypeAchatStore";
import TitreDeux from "@/components/atoms/TitreDeux.vue";

const notificationStore = NotificationStores();
const imprimanteStore = ImprimantesStore();
const typeAchatStore = TypeAchatStore();

typeAchatStore.loadTypeAchat();

const newMarque = ref("");
const newModel = ref("");
const newConsommation = ref();
const newPrix = ref();
const newUrlImage = ref("");
const newTypeAchat = ref(-1);
const newIp = ref("");

const typeAchatAvailable = computed(() => {
  return typeAchatStore.typeAchat.map((type) => {
    return {
      id: type.uuid,
      display: type.libelle
    }
  });
})

const createImprimante = () => {

  if(newMarque.value === "" || newModel.value === "" || newConsommation.value === 0 || newPrix.value === 0 || newUrlImage.value === "" || newTypeAchat.value === -1) {
    notificationStore.addNotification(t('needFillAllFields'), 'error');
    return;
  }

  console.log(newTypeAchat.value);

  imprimanteStore.createImprimante({
    marque: newMarque.value,
    modele: newModel.value,
    consommation: newConsommation.value,
    prix: newPrix.value,
    urlImage: newUrlImage.value,
    uuidTypeAchat: newTypeAchat.value,
    ip: newIp.value === "" ? null : newIp.value
  }, () => {
    newMarque.value = "";
    newModel.value = "";
    newConsommation.value = 0;
    newPrix.value = 0;
    newUrlImage.value = "";
    newIp.value = "";
  });
}
</script>

<style scoped>

</style>